import { render } from "./CreateSupplierReceipt.vue?vue&type=template&id=8f67bf86&scoped=true"
import script from "./CreateSupplierReceipt.vue?vue&type=script&lang=js"
export * from "./CreateSupplierReceipt.vue?vue&type=script&lang=js"

import "./CreateSupplierReceipt.vue?vue&type=style&index=0&id=8f67bf86&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f67bf86"]])

export default __exports__